module.exports = __webpack_public_path__ + "static/media/6.0ae2029c.png";